import { render, staticRenderFns } from "./KzsTemplateForm.vue?vue&type=template&id=32eeed3d"
import script from "./KzsTemplateForm.vue?vue&type=script&lang=js"
export * from "./KzsTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports